// extracted by mini-css-extract-plugin
module.exports = {"cardWrapper":"TeamCard_cardWrapper__3uxLB","imageWrapper":"TeamCard_imageWrapper__9Xmqs","cardContent":"TeamCard_cardContent__2fwfc"};